import { jsx as a, jsxs as p } from "react/jsx-runtime";
import { useTranslation as t } from "react-i18next";
import r from "./shortcut-card.module.less.js";
import c from "../link-wrapper/link-wrapper.js";
const j = ({ linkUrl: i, eyebrow: s, title: e, subTitle: o, target: l }) => {
  const { t: n } = t();
  return /* @__PURE__ */ a(
    c,
    {
      ariaLabel: `${n("CLICK_TO_READ_MORE_ABOUT")} ${e}`,
      url: i,
      className: r.wrapper,
      target: l,
      children: /* @__PURE__ */ p("div", { className: r.textWrapper, children: [
        s && /* @__PURE__ */ a("p", { className: [r.eyebrow, "eyebrow"].join(" "), children: s }),
        e && /* @__PURE__ */ a("p", { className: [r.title, "h5"].join(" "), children: e }),
        o && /* @__PURE__ */ a("p", { className: [r.subTitle, "body-s"].join(" "), children: o })
      ] })
    }
  );
};
export {
  j as ShortcutCard,
  j as default
};
